import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { toRepliconDate } from '~/modules/common/dates/convert';

export const TASK_RESOURCE_USER_ALLOCATIONS_SUMMARY_QUERY = gql`
  query GetTaskResourceUserAllocationsSummary(
    $userId: String!
    $filter: TaskResourceUserAllocationsSummaryForUserFilter
  ) {
    getTaskResourceUserAllocationsSummaryForUser(
      userId: $userId
      filter: $filter
    ) {
      userId
      startDate
      endDate
      totalHours
      scheduleRules {
        dateRange {
          startDate
          endDate
        }
        do
      }
    }
  }
`;

export const getTaskResourceUserAllocationsSummaryForUserQuery = ({
  userId,
  projectId,
  excludeTaskAllocationId,
  dateRange
}) => {
  return {
    query: TASK_RESOURCE_USER_ALLOCATIONS_SUMMARY_QUERY,
    variables: {
      userId,
      filter: {
        projectId,
        excludeTaskAllocationId,
        dateRange:
          dateRange?.startDate && dateRange?.endDate
            ? {
                startDate: toRepliconDate(dateRange.startDate),
                endDate: toRepliconDate(dateRange.endDate)
              }
            : undefined
      }
    }
  };
};
export const useGetTaskResourceUserAllocationsSummaryForUser = ({
  userId,
  projectId,
  taskAllocationId,
  dateRange,
  skip
}) => {
  const {
    query,
    variables
  } = getTaskResourceUserAllocationsSummaryForUserQuery({
    userId,
    projectId,
    excludeTaskAllocationId: taskAllocationId,
    dateRange
  });
  const { data, loading } = useQuery(query, {
    variables,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip
  });

  return {
    loading,
    taskResourceUserAllocationsSummary:
      data?.getTaskResourceUserAllocationsSummaryForUser || {}
  };
};

export default useGetTaskResourceUserAllocationsSummaryForUser;
